/* eslint-disable import/prefer-default-export */
export const createTemplateFormValuesSelector = (state) =>
  state.forms.template.create
